import { configureStore } from '@reduxjs/toolkit';

import loginReducer from './login-reducer/loginSlice';
import listReducer from './list-types-reducer/listTypesSlice';
import appSettingReducer from './app-setting-reducer/appSettingSlice';
import adminProfileReducer from './admin-reducer/profile-reducer/profileSlice';
import adminAccountReducer from './admin-reducer/account-reducer/accountsSlice';
import adminUserListReducer from './admin-reducer/users-reducer/usersListSlice';
import userAccountReducer from './user-reducers/user-account-reducer/userAccountSlice';
import userAccountListReducer from './user-reducers/list-accounts-reducer/listAccountSlice';
import listAdminAccountReducer from "./admin-reducer/list-account-reducer/listAdminAccountSlice";
import paymentReducer from "./user-reducers/payment-reducer/paymentSlice";

import { resetTimerMiddleware } from './middleware';

export const store = configureStore({
  reducer: {
    listStore: listReducer,
    loginStore: loginReducer,
    appSettingStore: appSettingReducer,
    userAccountStore: userAccountReducer,
    adminAccountStore: adminAccountReducer,
    adminProfileStore: adminProfileReducer,
    adminUserListStore: adminUserListReducer,
    userAccountListStore: userAccountListReducer,
    listAdminAccountStore: listAdminAccountReducer,
    paymentStore: paymentReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [
          'userAccountSlice/downloadDocumentThunk/fulfilled',
          'userAccountSlice/downloadTransactionThunk/fulfilled',
          'userAccountSlice/downloadDeliveriesThunk/fulfilled'
        ],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.data'],
        // Ignore these paths in the state
        ignoredPaths: ['userAccountStore.download'],
      },
    }).concat(resetTimerMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;